import { ReportIssueDialog } from '@/components/ReportIssueDialog';
import { useReportDialogStore } from '@/stores/reportDialogStore';

/**
 * ReportIssueDialogHost — 把 store 的開關接到對話框(R249 Step 1)
 *
 * 存在的理由只有一個:讓 [ReportIssueDialog](../components/ReportIssueDialog.tsx) 保持
 * **純受控**(props 只有 `onClose` / `initialCategory`),這樣同一個元件才能被
 * [AppErrorBoundary](./AppErrorBoundary.tsx) 用自己的 state 再 render 一份 —— 白畫面時
 * store 也可能是壞的那個環節,不該是必要依賴。
 */
export function ReportIssueDialogHost() {
  const open = useReportDialogStore((s) => s.open);
  const initialCategory = useReportDialogStore((s) => s.initialCategory);
  const close = useReportDialogStore((s) => s.closeReportDialog);
  if (!open) return null;
  return <ReportIssueDialog onClose={close} initialCategory={initialCategory} />;
}
